import getUniqueId from '@/shared/getUniqueId'
import { EthJsonRpcMethod } from '@/shared/models/jsonRPCMethod'
import { JsonRpcRequest } from '@/shared/models/JsonRpc'

/**
 * Creates a JSON-RPC 2.0 message.
 * @param method - The name of the method
 * @param params - The method's parameters
 */
export const createJRpcMessage = (
  method: EthJsonRpcMethod,
  params: unknown
): { id: string; message: string } => {
  const message: JsonRpcRequest<unknown> = {
    id: getUniqueId(),
    jsonrpc: '2.0',
    method,
    params,
  }

  return {
    id: message.id as string,
    message: JSON.stringify(message),
  }
}
